import { ActionTypeCreator } from 'app-webtech-core/actions/actionType';

const ActionType = new ActionTypeCreator('POD_TRACKER_ADS');

export const SET_ADS_DATA = ActionType.simple('SET_ADS_DATA');
export const REQUEST_ADS_DATA = ActionType.simple('REQUEST_ADS_DATA');
export const MARK_VOD_AD_WATCHED = ActionType.simple('MARK_VOD_AD_WATCHED');
export const VOD_SAVE_LAST_POSITION = ActionType.simple('VOD_SAVE_LAST_POSITION');
export const SET_ADS_PLAYING = ActionType.simple('SET_ADS_PLAYING');

export const CM_BEGIN = ActionType.simple('CM_BEGIN');
export const CM_END = ActionType.simple('CM_END');
export const CM_START = ActionType.simple('CM_START');
export const CM_FIRST_QUARTILE = ActionType.simple('CM_FIRST_QUARTILE');
export const CM_MID_POINT = ActionType.simple('CM_MID_POINT');
export const CM_THIRD_QUARTILE = ActionType.simple('CM_THIRD_QUARTILE');
export const CM_COMPLETE = ActionType.simple('CM_COMPLETE');
export const CM_POD_START = ActionType.simple('CM_POD_START');
export const CM_POD_COMPLETE = ActionType.simple('CM_POD_COMPLETE');
export const CM_POD_BEGIN = ActionType.simple('CM_POD_BEGIN');
export const CM_POD_END = ActionType.simple('CM_POD_END');
export const CM_IMPRESSION = ActionType.simple('CM_IMPRESSION');
export const CM_ERROR = ActionType.simple('CM_ERROR');
